import { render, staticRenderFns } from "./index.vue?vue&type=template&id=604b33f8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b33f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604b33f8')) {
      api.createRecord('604b33f8', component.options)
    } else {
      api.reload('604b33f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=604b33f8&scoped=true&", function () {
      api.rerender('604b33f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/list/index.vue"
export default component.exports